exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-line-table .el-table td[data-v-3abb0f36],.no-line-table .el-table th[data-v-3abb0f36],.no-line-table .el-table tr[data-v-3abb0f36]{border:0;background-color:transparent}.no-line-table[data-v-3abb0f36] .el-table th.is-leaf{border:none}.no-line-table[data-v-3abb0f36] .el-table__row:nth-child(2n){background:transparent}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3abb0f36","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ticket/hot-tickets.vue
// module id = 945
// module chunks = 0